import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel,
  ButtonGroup,
  Glyphicon
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import {marketList} from '../../../redux/actions/emailManagerActions';
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import moment from "moment";
import {
  renderAlert,
  clearAlert
} from "../../../redux/actions/alertsActions";
import Dialog from "react-bootstrap-dialog";
import "../../../style/listPage.scss";
import {aclUtil} from "../../util";
import Toggle from "react-bootstrap-toggle";

const history = createBrowserHistory();
let isLoading = "false";
class List extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'LIST_MARKET',
      list: [],
      totalRecords: 0,
      limit: 25,
      search: "",
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      legal_nameSortIcon: "glyphicon glyphicon-sort-by-attributes",
      account_nameSortIcon: "glyphicon glyphicon-sort-by-attributes",
      emailSortIcon: "glyphicon glyphicon-sort-by-attributes",
      deal_citySortIcon: "glyphicon glyphicon-sort-by-attributes",
      registeredOnSortIcon: "glyphicon glyphicon-sort-by-attributes",
      path: ["Home", "Market List"],
      links: ["home", "market/list"],
      show: false,
      direction: "",
      orderBy: ""
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleSelect(limit) {
    this.setState({
      limit: limit
    });
    const postData = {
      page: this.state.currentPage,
      limit: this.state.limit,
      search: this.state.search
    };

    this.props.marketList(postData);
  }

  handleSearch(e) {
    this.setState({ [e.target.name]: e.target.value });
    let searchstring = this.state.search.length > 1 ? this.state.search : "";
    const postData = {
      page: "1",
      limit: this.state.limit,
      search: e.target.value
    };
    if (e.target.value.length !== 0) {
      this.props.marketList(postData);
    } else {
      this.props.marketList({ page: this.state.currentPage,limit: this.state.limit });
    }
  }

  handleSort = orderBy => e => {
    e.preventDefault();

    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes-alt",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes-alt",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.marketList({ orderBy: orderBy, direction: direction,limit: this.state.limit });
  };

  handlePageChange = page => {
    this.setState({
      currentPage: page
    });

    const postData = {
      page: page,
      limit: this.state.limit,
      search: this.state.search ? this.state.search : ""
    };
    this.props.marketList(postData);
  };

  componentWillMount() {
    isLoading = "true";
    this.handleDismiss();
    this.props.clearAlert();
    this.props.marketList({ page: this.state.currentPage,limit: this.state.limit });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.list !== nextProps.list) {
      if (nextProps.list && nextProps.list.data) {
        const setPageCount =
          nextProps.list.data.total / nextProps.list.data.per_page;
        this.setState({
          list: nextProps.list.data.data,
          totalRecords: nextProps.list.data.total,
          perPage: nextProps.list.data.per_page,
          pageCount: 5
        });
        isLoading = "false";
      }
    }

    if (this.props.deleteStatus !== nextProps.deleteStatus) {
      if (!isEmpty(nextProps.deleteStatus)) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.deleteStatus.message);
        isLoading = "false";
        this.props.marketList({ page: this.state.currentPage,limit: this.state.limit });
        window.scrollTo(0, 0);
      }
    }

    if (this.props.status !== nextProps.status) {
      if (!isEmpty(nextProps.status)) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.status.message);
        isLoading = "false";
        this.props.marketList({ page: this.state.currentPage,limit: this.state.limit });
        window.scrollTo(0, 0);
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if (this.props.message !== nextProps.message) {
      if (nextProps.message) {
        this.setState({
          alertMessage: nextProps.message,
          msgType: nextProps.alertType
        });
      }
    }
  }

  handleDelete = charityID => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(charityID);
          this.handleShow();
        })
      ]
    });
  };

  confirmDelete = charityID => {
    isLoading = "true";
    this.props.deleteCharity(charityID);
  };

  handleClick = (e, id, charityStatus) => {
    this.dialog.show({
      body: "Are you sure you want to change charity status?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmStatus(e, id, charityStatus);
          this.handleShow();
        })
      ]
    });
  };

  confirmStatus = (e, id, charityStatus) => {
    isLoading = "true";
    if(charityStatus === 'active'){
      this.props.charityStatus({
        id: id,
        status: 'inactive',
      });
    }else{
      this.props.charityStatus({
        id: id,
        status: 'active',
      });
    }
  };

  redirectDashboard = affiliateID => {
    if (affiliateID) {
    }
  };

  redirectToWebSite = websiteUrl => {
    if (websiteUrl !== "http://") {
      var win = window.open(websiteUrl, "_blank");
      win.focus();
    }
  };

  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let charityRow;
    let listData = this.state.list
      ? this.state.list
      : [];

    if (!isEmpty(listData)) {
      charityRow = listData.map((market, index) => (
        <tr key={market.campaign_market_id}>
          <td>{market.market_name}</td>
          <td>{market.org_id}</td>
          <td>{market.audience_id}</td>
          <td>{market.station_audience_id}</td>
          <td>
            <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {aclUtil.checkACL('EDIT_MARKET') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/market/edit/${market.campaign_market_id}`)}><i className="glyphicon glyphicon-pencil"></i> Edit</MenuItem>):("")}
                </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }else{
      charityRow = <tr><td colSpan='5'>Data Not Found</td></tr>
    }

    return (
      <div>
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="col-lg-12 list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading panel-heading-index">
              <div className="row">
                <div className="col-lg-6 col-md-4 col-sm-12">
                  <h4>Market List</h4>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <FormGroup>
                    <InputGroup>
                      <FormControl type="text" name="search" onKeyUp={this.handleSearch} />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-12">
                  {aclUtil.checkACL('ADD_MARKET') ? (
                    <Button className="addMerchant"
                      bsSize="small"
                      bsStyle="success"
                      onClick={() => this.context.router.history.push("/market/add")}
                    >
                      + Add Market
                    </Button>)
                    : ("")}
                </div>
              </div>
            </header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="row">
                <div className="col-lg-12">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>
                          Market Name
                        </th>
                        <th>
                          Organisation Id
                        </th>
                        <th>Market Audience Id</th>
                        <th>Station Audience Id</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>{charityRow}</tbody>
                  </table>

                  <div className="text-center">
                    <Pagination
                      total={totalRecords}
                      limit={perPage}
                      pageCount={5}
                      currentPage={currentPage}
                    >
                      {({
                        pages,
                        currentPage,
                        hasNextPage,
                        hasPreviousPage,
                        previousPage,
                        nextPage,
                        totalPages,
                        getPageItemProps
                      }) => (
                        <div className="pagination">
                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: 1,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            first
                          </button>

                          {hasPreviousPage && (
                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: previousPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {"<"}
                            </button>
                          )}

                          {pages.map(page => {
                            let activePage = null;
                            if (currentPage === page) {
                              activePage = {
                                backgroundColor: "#ccc",
                                color: "#666"
                              };
                            }
                            return (
                              <button className="btn btn-default"
                                key={page}
                                style={activePage}
                                {...getPageItemProps({
                                  pageValue: page,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {page}
                              </button>
                            );
                          })}

                          {hasNextPage && (
                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: nextPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {">"}
                            </button>
                          )}

                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: totalPages,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            last
                          </button>
                        </div>
                      )}
                    </Pagination>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

List.propTypes = {
  marketList: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  list: state.emailManagerReducer.marketList,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message
});

export default connect(mapStateToProps, {
  marketList,
  renderAlert,
  clearAlert
})(List);



// WEBPACK FOOTER //
// ./src/app/views/admin/campaignMarket/List.js